import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import SimpleCard from './SimpleCard'
import GroupInviteButton from '../../pages/Groups/GroupInviteButton'

const cardProps = {
  headingFallback: 'Invite the whole family to share',
  headingKey: 'create-family-group-prompt.invite-the-whole-family',
  descriptionFallback:
    'Build stronger family connections and make unforgettable memories. By adding your family to a Family Group, you can start sharing your stories with each other.',
  descriptionKey: 'create-family-group-prompt.explanation',
}

export default function InviteGroupCard({ familyGroup }) {
  const { t } = useTranslation()
  const buttonCss = css`
    button {
      font-weight: bold;
    }
  `

  return (
    <SimpleCard {...cardProps}>
      <div css={buttonCss}>
        <GroupInviteButton
          familyGroup={familyGroup}
          buttonText={t('familygroups.card.inviteMembers.button', 'Invite Family Members')}
          showIcon={false}
          buttonProps={{ emphasis: 'low', color: 'purple' }}
          event_name="InviteGroupCard:INVITE_FAMILY_MEMBERS:CLICK"
          socialMenuProps={{
            buttonEmphasis: 'low',
            billboardButtonColor: 'purple',
          }}
          socialMenuAnalytics={{
            link_name: 'INVITE_FAMILY_MEMBERS',
            link_page: 'InviteGroupCard',
            link_app: 'DISCOVERY_KIDS',
          }}
        />
      </div>
    </SimpleCard>
  )
}
